import { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import { getConsentStatus, acceptConsent, rejectConsent } from '@/shared/lib/consent';
import { trackEvent } from '@/shared/lib/analytics';

export function CookieConsent() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(() => getConsentStatus() === 'pending');

  const handleAccept = () => {
    trackEvent('consent:accepted');
    acceptConsent();
    setVisible(false);
  };

  const handleReject = () => {
    trackEvent('consent:rejected');
    rejectConsent();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-4 pointer-events-none">
      <div className="mx-auto max-w-lg rounded-lg border border-white/10 bg-black/90 backdrop-blur-md p-4 shadow-lg pointer-events-auto">
        <div className="flex items-start gap-3">
          <Cookie className="size-5 text-primary shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm text-white/70">
              <Trans
                i18nKey="legal.cookies.banner"
                components={{
                  privacy: <Link to="/privacy" className="text-primary underline hover:text-primary/80" />,
                }}
              />
            </p>
            <div className="flex gap-2 mt-3">
              <Button
                size="sm"
                variant="default"
                onClick={handleAccept}
              >
                {t('legal.cookies.accept')}
              </Button>
              <Button
                size="sm"
                variant="ghost"
                className="text-white/50 hover:text-white"
                onClick={handleReject}
              >
                {t('legal.cookies.reject')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
